import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {axios} from './lib/backend'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import Toastr from 'vue-toastr';
import vSelect from 'vue-select'
import * as svgicon from 'vue-svgicon';
import Auth from './lib/mixins/Auth';
import Strings from './lib/mixins/Strings';

import './assets/scss/vue-toastr.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'mdi/scss/materialdesignicons.scss'
import '@mdi/font/css/materialdesignicons.css'

import VueRouterUserRoles from "vue-router-user-roles";
Vue.use(svgicon, {
  classPrefix: 'AppIcon-',
});

Vue.use(VueRouterUserRoles, { router });

Vue.component('v-select', vSelect)
Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(Toastr);
Vue.use(require('vue-moment'));
Vue.mixin(Auth);
Vue.mixin(Strings);
new Vue({
	Toastr,
	router,
	store,
	axios,
  render: h => h(App)
}).$mount('#app')



// console.log(process.env.NODE_ENV)
// console.log(process.env.VUE_APP_BASE_URI)